import { ReactNode } from "react";
import Flex from "../../../../../../components/Flex";

/**
 * @module patient-chart [sub sections]
 * @returns Responsive grid for patient chart
 *
 * @author Rajkumar Rathod
 */
const ResponsiveFlex = ({ children }: { children: ReactNode }) => {
  return (
    <Flex
      flex={1}
      width={"calc(100vw - 250px)"}
      sx={{ overflowY: "auto", mt: 1 }}
    >
      {children}
    </Flex>
  );
};

export default ResponsiveFlex;
